import { useCallback } from "react";
import type { MediaAsset } from "@eaub/shared";
import { useApi } from "../api/ApiProvider";
import { useAsync } from "../lib/useAsync";
import { Spinner } from "../components/Spinner";
import { ErrorBanner } from "../components/ErrorBanner";
import { MediaGrid } from "../components/MediaGrid";
import { UploadControl } from "../components/UploadControl";

export function MediaLibrary() {
  const api = useApi();
  const load = useCallback(() => api.listMedia(), [api]);
  const { data, loading, error, reload } = useAsync<MediaAsset[]>(load, [load]);

  return (
    <div className="page">
      <div className="page__header">
        <div>
          <h1 className="page__title">Media Library</h1>
          <p className="page__subtitle">Images and files available to your content.</p>
        </div>
        <div className="page__actions">
          <UploadControl onUploaded={reload} />
        </div>
      </div>

      {loading ? <Spinner label="Loading media…" /> : null}
      {error ? <ErrorBanner message={error.message} onRetry={reload} /> : null}
      {data ? <MediaGrid assets={data} showCopy /> : null}
    </div>
  );
}
